export default "__VITE_ASSET__B7H52Wea__"